import { Injectable } from '@angular/core';
import { UidrServices } from './uidr.model';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { encryptionService } from '../common-service/cedService';
import { ServerURLService } from '../common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class UidrService {
  constructor(public http: HttpServiceService, private url: UidrServices, private toastr: ToastrService, 
    private ced: encryptionService, private serverURL: ServerURLService) { }
  uidrSignup(data: any) {
    return this.http.post(this.url.uidrSignup, data);
  }

  uidrUserRegistration(data: any) {
  return this.http.post(this.url.uidrUserRegistration, data);
}
  
  //  getAllCountries
  getAllCountry() {
    return this.http.get(this.url.getAllCountry);
  }

  // getAllStates
  getAllStates(countryId: any) {
    return this.http.get(this.url.getAllStates + '?countryId=' + countryId);
  }
  // getAllCities
  getAllCities(stateId: any) {
    return this.http.get(this.url.getAllCities + '?stateId=' + stateId);
  }
  //GetAllCourses
  getAllCourses() {
    return this.http.get(this.url.getAllCourses);
  }
  
  // getSpecializationsByCourseId
  getSpecializations() {
    return this.http.get(this.url.getSpecialisationByCourseId);
  }
  // IsAlreadyExist(uidrDetails:any) {
  //   return this.http.post(this.url.IsAlreadyExist,uidrDetails);
  // }
  getSDCList() {
    return this.http.get(this.url.getSDCList);
  }
  GetSDCById(entityMasterId:any) {
    const obj = {
      entityMasterIdEncr: this.ced.encryptAesToString(entityMasterId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.GetSDCById, obj);
  }
  GetUIDRDetailsList(uidrSearchCriteria:any){
    return this.http.post(this.url.GetUIDRDetailsList ,uidrSearchCriteria);
  }
  GetUIDRDetailsListForCandidate(uidrSearchCriteria:any){
    return this.http.post(this.url.GetUIDRDetailsListForCandidate ,uidrSearchCriteria);
  }
  IsAlreadyUIDRExist(userId: any){
    return this.http.get(this.url.IsAlreadyUIDRExist +'?userId='+userId);
  }
  IsAlreadyUIDRDetails(uidrDetails: any){
    return this.http.post(this.url.IsAlreadyUIDRDetails,uidrDetails);
  }
  GetUIDRDetailsListForSection(uidrSearchCriteria:any){
    return this.http.post(this.url.GetUIDRDetailsListForSection ,uidrSearchCriteria);
  }
  GetUIDRDetailsListForTransfer(uidrSearchCriteria:any){
    return this.http.post(this.url.GetUIDRDetailsListForTransfer ,uidrSearchCriteria);
  }
  getUIDRDetails(uidrDetailsId: any){
    const obj = {
      uidrDetailsIdEncr: this.ced.encryptAesToString(uidrDetailsId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.GetUIDRDetails, obj);
  }
  GetUIDRDetailsByUser(userId: any){
    return this.http.get(this.url.GetUIDRDetailsByUser +'?userId='+userId);
  }
  getUIDRDetailsHistory(uidrDetailsId: any){
    const obj = {
      uidrDetailsIdEncr: this.ced.encryptAesToString(uidrDetailsId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.GetUIDRDetailsHistory, obj);
  }
  // getUIDRQualificationList(uidrDetailsId: any){
  //   return this.http.get(this.url.GetUIDRQualificationList +'?uidrDetailsId='+uidrDetailsId);
  // }
  getfiles(filename){
    return this.http.get(this.url.files+filename);
  }
  DownloadUIDRCertificate(uidrDetailsId: any){
    const obj = {
      uidrDetailsIdEncr: this.ced.encryptAesToString(uidrDetailsId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.DownloadUIDRCertificate, obj);
  }
  DownloadUploadedUIDRCertificate(uidrDetailsId: any){
    const obj = {
      uidrDetailsIdEncr: this.ced.encryptAesToString(uidrDetailsId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.DownloadUploadedUIDRCertificate, obj);
  }
  DownloadUploadedUIDRHistoryCertificate(fileName:any)
  {
    return this.http.get(this.url.DownloadUploadedUIDRHistoryCertificate +'?fileName='+fileName);
  }
  SaveUIDRDetails(uidrDetailsDTO:any) {
    return this.http.post(this.url.SaveUIDRDetails,uidrDetailsDTO);
  }
  ApproveUIDRDetails(uidrDetailsDTO:any) {
    return this.http.post(this.url.ApproveUIDRRegistration,uidrDetailsDTO);
  }
  RejectUIDRDetails(uidrDetailsDTO:any) {
    return this.http.post(this.url.RejectUIDRRegistration,uidrDetailsDTO);
  }
  UpdateUIDRDetails(uidrDetails:any) {
    return this.http.post(this.url.UpdateUIDRDetails,uidrDetails);
  }
  FileUploadForUIDRCertificate(filearray:any) {
    const formdata = new FormData();
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }
    //formdata.append('columnFilePath',filecolumn);
    return this.http.post(this.url.FileUploadForUIDRCertificateUrl,formdata);
  }
  public personalloadEndate() {
    var birthDate = new Date();
    var month = ("0" + (birthDate.getMonth() + 1)).slice(-2);
    var day = ("0" + birthDate.getDate()).slice(-2);
    return birthDate.getFullYear()-19+'-'+month+'-'+day
  }
  
  
  displayMessage(type, msg){
    if(type === 'Error'){
      this.toastr.error(msg, 'Error', { timeOut: 3000});
    }
  }

  uidrCertificateAuthenticate(obj) {
    return this.http.post(this.url.uidrCertificateAuthenticate, obj);
  }
}
